import React from "react";

interface GreyCardVerticalProps {
  children: React.ReactNode;
}

const GreyCardVertical: React.FC<GreyCardVerticalProps> = ({ children }) => {
  return (
    <div className="w-full h-full p-4 bg-[#eaebf0] rounded-[36px] border flex-col justify-center  mt-3 gap-4 inline-flex mx-auto">
      {/* Marco Gris */}
      <div className="self-stretch h-full p-4 bg-white rounded-3xl flex flex-col justify-center text-left gap-2 w-full">
        {children}
      </div>
    </div>
  );
};

export default GreyCardVertical;

/*
    <div className="w-full h-full p-4 bg-[#eaebf0] rounded-[36px] border flex-col justify-center  mt-3 gap-4 inline-flex mx-auto">
      <div className="self-stretch h-full p-2 bg-white rounded-3xl flex justify-center  gap-10 flex">
        {children}
      </div>
    </div>
*/